// extracted by mini-css-extract-plugin
module.exports = {"items":"styles_items__ASquv","item":"styles_item__hwr9S","item__icon":"styles_item__icon__NDGSq","item__text":"styles_item__text__JhUL5"};